<template>
  <res-dialog :showDialog="showDialog"
              :maxWidth="maxWidth"
              :setWidth="setWidth"
              :title="'Copy Template?'"
              :titleClass="'resBlue darken-1 white--text'"
              :showTitleIcon="true"
              :titleIconSize="17"
              :iconColor="'white'"
              :saveButtonText="'YES, COPY'"
              :saveDisabled="false"
              :cancelButtonText="'CANCEL'"
              :cancelButtonWidth="'80'"
              :defaultButtonAction="confirmCopy"
              @save="confirmCopy"
              @cancel="confirmCancel" >
    <v-card-text>
      <span class="font-weight-500">
         {{message}}
      </span>
    </v-card-text>
  </res-dialog>
</template>

<script>
  import ResDialog from '@/components/base/ResDialog.vue';

  export default {
    components: {
      ResDialog
    },
    props: {
      showDialog: {
        type: Boolean
      },
      templateTitle: {
        type: String
      },
      maxWidth: {
        type: Number
      },
      setWidth: {
        type: Number
      },
    },
    methods: {
      confirmCancel() {
        this.$emit('cancelCopy', true)
      },
      confirmCopy() {
        this.$emit('confirmCopy', true)
      }
    },
    computed: {
      message() {
        return `Are you sure you want to copy the '${this.templateTitle}' template?`;
      } 
    }
  }
</script>

